export const normalizeEnrolleeNumber = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value)
    .trim()
    .replace(/[_~]/g, "-")
    .replace(/\s*-\s*/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const normalizeEnrolleeSearchValue = (value) => {
  const original = value === null || value === undefined ? "" : String(value).trim();
  const normalized = normalizeEnrolleeNumber(original);

  return normalized || original;
};
